import  { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Dashbaord/Layout.js/Layout';
import {
  FaFileInvoice, FaTimes, FaUpload
} from 'react-icons/fa';
import {
  Container, Row, Col,
  Form, Button, Alert, Spinner
} from 'react-bootstrap';
import { createBill } from '../../../../services/bills.services';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import EventDetailsForm from './components/EventDetailsForm';
import MenuSelection from './components/MenuSelection';
import BillDetails from './components/BillDetails';
import PreviewModal from './components/PreviewModal';
import MenuSelectionModal from './components/MenuSelectionModal';


import {
  traditionalMehndiMenus, baratWalimaMenus, ronaqPremiumMenus,
  desserts, bbqMenu, muttonMenu, seaFoodMenu,
  chineseMenu, friedDryMenu, othersMenu, desiMenu
} from '../../../../data/menus';
import { colors } from '../../../../utils/Colors';

const CreateNewBill = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [showMenuModal, setShowMenuModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [formData, setFormData] = useState({
    eventDetails: {
      name: '',
      cnic: '',
      dateOfEvent: '',
      dayOfEvent: '',
      ladies: '',
      gents: '',
      venue: '',
      advancePayment: '',
      lunchDinner: '',
      persons: '',
      mob1: '',
      mob2: '',
    },

    billDetails: {
      foodBill: '',
      djMusic: '',
      serviceCharges: '',
      hallRent: '',
      bwdStage: '',
      acCharges: '',
      heaterCharges: '',
      ladiesWaiter: '',
      govtTax: '',
      otherCharges: '',
      totalAmount: '',
      remainingAmount: '',
      includeTax: false
    },

    menu: [],
    selectedMainMenu: '',
    mainMenuPrice: 0,
    mainMenuItems: [],

    perHead: '',
    customPerHead: '',
    serviceType: 'Table',
    selectedIndividualItems: [],
  });

  // Calculation functions (same as before)
  const calculateFoodBill = () => {
    const persons = parseInt(formData.eventDetails.persons) || 0;
    let totalFoodBill = 0;

    if (formData.selectedMainMenu && formData.mainMenuPrice > 0) {
      totalFoodBill = formData.mainMenuPrice * persons;
    }
    else if (formData.customPerHead && parseFloat(formData.customPerHead) > 0) {
      totalFoodBill = parseFloat(formData.customPerHead) * persons;
    }
    else if (formData.menu.length > 0) {
      totalFoodBill = formData.menu.reduce((sum, item) => {
        const price = parseFloat(item.price) || 0;
        return sum + price;
      }, 0);
    }

    return totalFoodBill;
  };

  const calculatePerHead = () => {
    const persons = parseInt(formData.eventDetails.persons) || 0;
    const foodBill = calculateFoodBill();

    if (persons > 0 && foodBill > 0) {
      return Math.round(foodBill / persons);
    }
    return 0;
  };

  const calculateGovtTax = () => {
    const foodBill = calculateFoodBill();
    return Math.round(foodBill * 0.05);
  };

 const calculateTotalAmount = () => {
  const foodBill = calculateFoodBill();
  const djMusic = parseInt(formData.billDetails.djMusic) || 0;
  const serviceCharges = parseInt(formData.billDetails.serviceCharges) || 0;
  const hallRent = parseInt(formData.billDetails.hallRent) || 0;
  const bwdStage = parseInt(formData.billDetails.bwdStage) || 0;
  const acCharges = parseInt(formData.billDetails.acCharges) || 0;
  const heaterCharges = parseInt(formData.billDetails.heaterCharges) || 0;
  const ladiesWaiter = parseInt(formData.billDetails.ladiesWaiter) || 0;
  const otherCharges = parseInt(formData.billDetails.otherCharges) || 0;

  const isTaxIncluded = formData.billDetails.includeTax === true;
  const govtTax = isTaxIncluded ? calculateGovtTax() : 0;

  return (
    foodBill +
    djMusic +
    serviceCharges +
    hallRent +
    bwdStage +
    acCharges +
    heaterCharges +
    ladiesWaiter +
    govtTax +
    otherCharges
  );
};


  const calculateRemainingAmount = () => {
    const totalAmount = calculateTotalAmount();
    const advancePayment = parseInt(formData.eventDetails.advancePayment) || 0;
    return totalAmount - advancePayment;
  };

const updateCalculations = () => {
  const foodBill = calculateFoodBill();
  const perHead = calculatePerHead();

  const isTaxIncluded = formData.billDetails.includeTax === true;
  const govtTax = calculateGovtTax();
  const effectiveTax = isTaxIncluded ? govtTax : 0;

  const totalAmount =
    foodBill +
    (parseInt(formData.billDetails.djMusic) || 0) +
    (parseInt(formData.billDetails.serviceCharges) || 0) +
    (parseInt(formData.billDetails.hallRent) || 0) +
    (parseInt(formData.billDetails.bwdStage) || 0) +
    (parseInt(formData.billDetails.acCharges) || 0) +
    (parseInt(formData.billDetails.heaterCharges) || 0) +
    (parseInt(formData.billDetails.ladiesWaiter) || 0) +
    effectiveTax +
    (parseInt(formData.billDetails.otherCharges) || 0);

  const advance = parseInt(formData.eventDetails.advancePayment) || 0;

  setFormData(prev => ({
    ...prev,
    perHead: perHead.toString(),
    billDetails: {
      ...prev.billDetails,
      foodBill: foodBill.toString(),
      govtTax: govtTax.toString(), // sirf display
      totalAmount: totalAmount.toString(),
      remainingAmount: (totalAmount - advance).toString()
    }
  }));
};


  // Event handlers (same as before)
  const handleEventDetailsChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      eventDetails: {
        ...prev.eventDetails,
        [name]: value
      }
    }));
    setTimeout(() => updateCalculations(), 100);
  };

  const handleBillDetailsChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      billDetails: {
        ...prev.billDetails,
        [name]: value.replace(/\./g, '')
      }
    }));
    setTimeout(() => updateCalculations(), 100);
  };

  const handleMenuChange = (index, field, value) => {
    const updatedMenu = [...formData.menu];
    updatedMenu[index] = {
      ...updatedMenu[index],
      [field]: value
    };

    const updatedFormData = {
      ...formData,
      menu: updatedMenu,
      selectedMainMenu: '',
      mainMenuPrice: 0,
      mainMenuItems: [],
      customPerHead: ''
    };

    setFormData(updatedFormData);
    setTimeout(() => updateCalculations(), 100);
  };

  const addCustomMenuItem = () => {
    const newItem = { item: '', price: 0 };
    setFormData(prev => ({
      ...prev,
      menu: [...prev.menu, newItem],
      selectedMainMenu: '',
      mainMenuPrice: 0,
      mainMenuItems: [],
      customPerHead: ''
    }));
    toast.info('New custom item added', {
      position: "bottom-right",
      autoClose: 2000,
    });
  };

  const removeMenuItem = (index) => {
    const updatedMenu = formData.menu.filter((_, i) => i !== index);
    setFormData(prev => ({
      ...prev,
      menu: updatedMenu
    }));
    setTimeout(() => updateCalculations(), 100);
    toast.warning('Menu item removed', {
      position: "bottom-right",
      autoClose: 2000,
    });
  };

  const handleMainMenuSelect = (menu) => {
    const updatedFormData = {
      ...formData,
      menu: [],
      selectedMainMenu: menu.title,
      mainMenuPrice: menu.price || 0,
      mainMenuItems: menu.items || [],
      selectedIndividualItems: [],
      customPerHead: ''
    };

    setFormData(updatedFormData);
    setShowMenuModal(false);
    setTimeout(() => updateCalculations(), 100);

    toast.success(`"${menu.title}" selected - PKR ${menu.price} per person`, {
      position: "bottom-right",
      autoClose: 3000,
    });
  };

  const addIndividualItem = (item, category) => {
    const exists = formData.menu.some(menuItem => menuItem.item === item.name);
    if (!exists) {
      const priceValue = item.price ? item.price.toString().replace(/\./g, '') : '0';

      const newMenuItem = {
        item: item.name,
        price: priceValue,
        category: category
      };

      const updatedFormData = {
        ...formData,
        menu: [...formData.menu, newMenuItem],
        selectedMainMenu: '',
        mainMenuPrice: 0,
        mainMenuItems: [],
        customPerHead: '',
        selectedIndividualItems: [...formData.selectedIndividualItems, item.name]
      };

      setFormData(updatedFormData);
      setTimeout(() => updateCalculations(), 100);

      const priceText = item.price ? ` (PKR ${item.price})` : '';
      toast.success(`"${item.name}"${priceText} added`, {
        position: "bottom-right",
        autoClose: 2000,
      });
    } else {
      toast.warning(`"${item.name}" already in menu`, {
        position: "bottom-right",
        autoClose: 2000,
      });
    }
  };

  const handleCustomPerHeadChange = (e) => {
    const value = e.target.value.replace(/\./g, '');
    const updatedFormData = {
      ...formData,
      customPerHead: value,
      selectedMainMenu: '',
      mainMenuPrice: 0,
      mainMenuItems: [],
    };
    setFormData(updatedFormData);
    setTimeout(() => updateCalculations(), 100);
  };

  const resetForm = () => {
    if (window.confirm('Are you sure you want to reset the form? All data will be lost.')) {
      setFormData({
        eventDetails: {
          name: '',
          cnic: '',
          dateOfEvent: '',
          dayOfEvent: '',
          ladies: '',
          gents: '',
          venue: '',
          advancePayment: '',
          lunchDinner: '',
          persons: '',
          mob1: '',
          mob2: '',
        },
        billDetails: {
          foodBill: '',
          djMusic: '',
          serviceCharges: '',
          hallRent: '',
          bwdStage: '',
          acCharges: '',
          heaterCharges: '',
          ladiesWaiter: '',
          govtTax: '',
          otherCharges: '',
          totalAmount: '',
          remainingAmount: ''
        },
        menu: [],
        perHead: '',
        customPerHead: '',
        serviceType: 'Table',
        selectedMainMenu: '',
        mainMenuPrice: 0,
        mainMenuItems: [],
        selectedIndividualItems: [],
      });
      toast.info('Form has been reset', {
        position: "bottom-right",
        autoClose: 2000,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    const loadingToast = toast.loading('Creating bill...', {
      position: "bottom-right",
    });

    try {
      if (!formData.eventDetails.name.trim()) {
        toast.dismiss(loadingToast);
        toast.error('Customer name is required', { position: "bottom-right", autoClose: 3000 });
        setLoading(false);
        return;
      }

      if (!formData.eventDetails.persons || parseInt(formData.eventDetails.persons) <= 0) {
        toast.dismiss(loadingToast);
        toast.error('Please enter valid number of persons', { position: "bottom-right", autoClose: 3000 });
        setLoading(false);
        return;
      }

      const backendMenuItems = [];

      if (formData.selectedMainMenu && formData.mainMenuItems.length > 0) {
        formData.mainMenuItems.forEach((item, index) => {
          backendMenuItems.push({
            item: `${index + 1}. ${item}`
          });
        });
      }

      if (formData.menu.length > 0) {
        formData.menu.forEach((item, index) => {
          if (item.item && item.item.trim() !== '') {
            const itemName = item.category
              ? `${item.category}: ${item.item}`
              : item.item;
            backendMenuItems.push({
              item: itemName
            });
          }
        });
      }

      let calculatedPerHead = 0;
      const persons = parseInt(formData.eventDetails.persons) || 0;
      const foodBill = calculateFoodBill();

      if (persons > 0 && foodBill > 0) {
        calculatedPerHead = Math.round(foodBill / persons);
      }

      const billData = {
        eventDetails: {
          name: formData.eventDetails.name.trim(),
          cnic: formData.eventDetails.cnic.trim(),
          dateOfEvent: formData.eventDetails.dateOfEvent || new Date().toISOString().split('T')[0],
          dayOfEvent: formData.eventDetails.dayOfEvent.trim(),
          ladies: parseInt(formData.eventDetails.ladies) || 0,
          gents: parseInt(formData.eventDetails.gents) || 0,
          venue: formData.eventDetails.venue.trim(),
          advancePayment: parseInt(formData.eventDetails.advancePayment) || 0,
          lunchDinner: formData.eventDetails.lunchDinner.trim(),
          persons: persons,
          mob1: formData.eventDetails.mob1.trim(),
          mob2: formData.eventDetails.mob2.trim(),
        },
        billDetails: {
          foodBill: foodBill || 0,
          djMusic: parseInt(formData.billDetails.djMusic) || 0,
          serviceCharges: parseInt(formData.billDetails.serviceCharges) || 0,
          hallRent: parseInt(formData.billDetails.hallRent) || 0,
          bwdStage: parseInt(formData.billDetails.bwdStage) || 0,
          acCharges: parseInt(formData.billDetails.acCharges) || 0,
          heaterCharges: parseInt(formData.billDetails.heaterCharges) || 0,
          ladiesWaiter: parseInt(formData.billDetails.ladiesWaiter) || 0,
          govtTax: parseInt(calculateGovtTax()) || 0,
          otherCharges: parseInt(formData.billDetails.otherCharges) || 0,
          totalAmount: parseInt(calculateTotalAmount()) || 0,
          remainingAmount: parseInt(calculateRemainingAmount()) || 0,
        },
        menu: backendMenuItems,
        perHead: calculatedPerHead,
        serviceType: formData.serviceType,
        status: 'pending'
      };

      const response = await createBill(billData);

      if (response.data.success) {
        toast.dismiss(loadingToast);
        toast.success('✅ Bill created successfully!', {
          position: "bottom-right",
          autoClose: 3000,
        });

        const createdBill = response.data.bill || response.data.data;
        const billId = createdBill._id || createdBill.id;

        setTimeout(() => {
          navigate(`/admin/dashboard/view-bill/${billId}`);
        }, 2000);
      } else {
        throw new Error(response.data.message || 'Failed to create bill');
      }
    } catch (err) {
      console.error('Error creating bill:', err);
      toast.dismiss(loadingToast);
      toast.error(`❌ ${err.response?.data?.message || err.message || 'Something went wrong. Please try again.'}`, {
        position: "bottom-right",
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    const num = amount ? parseInt(amount.toString().replace(/\./g, '')) : 0;
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(num);
  };

  // Filter menus
  const filteredMenus = [
    ...traditionalMehndiMenus,
    ...baratWalimaMenus,
    ...ronaqPremiumMenus
  ].filter(menu =>
    menu.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    menu.items.some(item => item.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <Layout>
      <Container fluid className="p-4">
        <Row className="mb-4 align-items-center p-4 rounded-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
          <Col md={6}>
            <div>
              <h2 className="fw-bold mb-2 text-white">
                <FaFileInvoice className="me-2" />
                Create New Bill
              </h2>
              <p className="text-white-50 mb-0">
                Fill in all the details below to create a new bill
              </p>
            </div>
          </Col>
          <Col md={6} className="text-md-end">
            <div className="d-flex gap-2 justify-content-md-end">
              <Button
                variant="outline-light"
                onClick={() => navigate('/admin/dashboard/bills-list')}
                className="d-flex align-items-center gap-2"
              >
                <FaTimes />
                Cancel
              </Button>
              <Button
                variant="outline-light"
                onClick={() => setShowPreview(true)}
                className="d-flex align-items-center gap-2"
              >
                <FaUpload />
                Preview
              </Button>
              <Button
                variant="light"
                onClick={resetForm}
                className="d-flex align-items-center gap-2"
              >
                Reset Form
              </Button>
            </div>
          </Col>
        </Row>

        {success && <Alert variant="success" className="mb-4">{success}</Alert>}
        {error && <Alert variant="danger" className="mb-4">{error}</Alert>}

        <div style={{ width: '95%', margin: '0 auto' }}>
          <Form onSubmit={handleSubmit}>
            {/* Use modular components */}
            <EventDetailsForm
              formData={formData}
              handleEventDetailsChange={handleEventDetailsChange}
              handleCustomPerHeadChange={handleCustomPerHeadChange}
            />

            <MenuSelection
              formData={formData}
              setShowMenuModal={setShowMenuModal}
              handleMenuChange={handleMenuChange}
              removeMenuItem={removeMenuItem}
              addCustomMenuItem={addCustomMenuItem}
              formatCurrency={formatCurrency}
              calculateFoodBill={calculateFoodBill}
              updateCalculations={updateCalculations}
              setFormData={setFormData}
            />

            <BillDetails
              formData={formData}
              handleBillDetailsChange={handleBillDetailsChange}
              calculateFoodBill={calculateFoodBill}
              calculateGovtTax={calculateGovtTax}
              calculatePerHead={calculatePerHead}
              calculateTotalAmount={calculateTotalAmount}
              calculateRemainingAmount={calculateRemainingAmount}
              formatCurrency={formatCurrency}
              setFormData={setFormData}
            />

            <Row className="mt-4">
              <Col md={12} className="text-center">
                <Button
                  variant="danger"
                  onClick={resetForm}
                  className="me-3 px-4 py-2"
                  disabled={loading}
                >
                  Reset Form
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading}
                  className="px-5 py-2"
                  style={{ backgroundColor: colors.TABLE_HEADERS, borderColor: colors.TABLE_HEADERS }}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Creating Bill...
                    </>
                  ) : (
                    <>
                      <FaFileInvoice className="me-2" />
                      Create Bill
                    </>
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>

        <PreviewModal
          show={showPreview}
          onHide={() => setShowPreview(false)}
          formData={formData}
          formatCurrency={formatCurrency}
          calculateFoodBill={calculateFoodBill}
          calculatePerHead={calculatePerHead}
          calculateGovtTax={calculateGovtTax}
          calculateTotalAmount={calculateTotalAmount}
          calculateRemainingAmount={calculateRemainingAmount}
          handleSubmit={handleSubmit}
          loading={loading}
        />

        <MenuSelectionModal
          show={showMenuModal}
          onHide={() => setShowMenuModal(false)}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filteredMenus={filteredMenus}
          handleMainMenuSelect={handleMainMenuSelect}
          addIndividualItem={addIndividualItem}
          traditionalMehndiMenus={traditionalMehndiMenus}
          baratWalimaMenus={baratWalimaMenus}
          ronaqPremiumMenus={ronaqPremiumMenus}
          bbqMenu={bbqMenu}
          muttonMenu={muttonMenu}
          seaFoodMenu={seaFoodMenu}
          chineseMenu={chineseMenu}
          friedDryMenu={friedDryMenu}
          desserts={desserts}
          othersMenu={othersMenu}
          desiMenu={desiMenu}
          formatCurrency={formatCurrency}
        />
      </Container>
    </Layout>
  );
};

export default CreateNewBill;